/* GamePulse 12.2: native Shopify custom events; no external tag or customer data. */
(function () {
  'use strict';
  var config = {};
  try { config = JSON.parse(document.getElementById('GamePulseConfig').textContent); } catch (error) {}
  var pending = [];
  var timer = null;
  var attempts = 0;
  var loadingPrivacy = false;
  var allowedKeys = ['campaign', 'placement', 'source', 'product_id', 'product_title', 'variant_id', 'title', 'selection', 'price', 'quantity', 'items', 'results', 'category', 'label'];
  function permission() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.analyticsProcessingAllowed === 'function' ? privacy.analyticsProcessingAllowed() : null;
    } catch (error) { return null; }
  }
  function loadPrivacy() {
    if (loadingPrivacy || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    loadingPrivacy = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { flush(); });
  }
  function clean(detail) {
    var safe = {};
    allowedKeys.forEach(function (key) {
      var value = detail && detail[key];
      if (typeof value === 'number' && Number.isFinite(value)) safe[key] = value;
      if (typeof value === 'string') safe[key] = value.slice(0, 180);
    });
    // Search terms can contain personal information; record length only.
    if (detail && typeof detail.query === 'string') safe.query_length = Math.min(detail.query.length, 200);
    safe.theme_version = config.version || '12.2.0';
    safe.currency = config.currency || '';
    safe.event_id = window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
    return safe;
  }
  function flush() {
    if (timer) window.clearTimeout(timer);
    timer = null;
    var consent = permission();
    if (consent === false) { pending = []; attempts = 0; return; }
    var api = window.Shopify && window.Shopify.analytics;
    if (consent === true && api && typeof api.publish === 'function') {
      var batch = pending.splice(0);
      attempts = 0;
      batch.forEach(function (entry) {
        try {
          var result = api.publish('gamepulse:' + entry.name, entry.data);
          if (result && typeof result.catch === 'function') result.catch(function () {});
          if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'gamepulse_' + entry.name, gamepulse: entry.data });
        } catch (error) {}
      });
      return;
    }
    loadPrivacy();
    if (pending.length && attempts < 16) {
      attempts += 1;
      timer = window.setTimeout(flush, 500);
    } else if (attempts >= 16) { pending = []; }
  }
  window.GamePulseEvents = {
    emit: function (name, detail) {
      if (config.analyticsEnabled === false || !/^[a-z][a-z0-9_]{0,60}$/.test(name) || permission() === false) return;
      if (pending.length >= 20) pending.shift();
      pending.push({ name: name, data: clean(detail || {}) });
      attempts = 0;
      flush();
    }
  };
  document.addEventListener('visitorConsentCollected', function () {
    // A refusal drops pending events. Events suppressed before consent are never replayed.
    pending = [];
    attempts = 0;
    flush();
  });
})();
